export default {
    topics: [
        {
            title: 'Database',
            href: 'f-sqlExec.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4298',
            next: 'tocId-d66e4298',
        },
        {
            title: 'File',
            href: 'f-loadString.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4428',
            next: 'tocId-d66e4428',
        },
        {
            title: 'Log',
            href: 'f-logInfo.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4517',
            next: 'tocId-d66e4517',
        },
        {
            title: 'Miscellaneous',
            href: 'f-loadLibrary.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4550',
            next: 'tocId-d66e4550',
        },
        {
            title: 'System',
            href: 'f-sleep.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4809',
            next: 'tocId-d66e4809',
        },
        {
            title: 'Workflow',
            href: 'f-getEventFromTransition.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4842',
            next: 'tocId-d66e4842',
        },
    ],
};

